import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { DEEP_GREEN, MUTED } from '../colorTokens';
import { GATE_COLOR, GATE_LABEL, GATE_TITLE, KIND_LABEL, formatNumber, formatPercent } from './format';

export const GateChip = ({ gate, status, compact }) => (
  <Tooltip title={`${GATE_TITLE[gate]}: ${GATE_LABEL[gate][status]}`} placement="top">
    <Chip
      size="small"
      label={GATE_LABEL[gate][status]}
      sx={{
        height: compact ? 22 : 24,
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.75rem',
        color: status === 'na' ? '#616161' : '#fff',
        bgcolor: status === 'na' ? 'rgba(0,0,0,0.07)' : GATE_COLOR[status]
      }}
    />
  </Tooltip>
);

const SEGMENTS = [
  { key: 'passed', label: 'Passed', color: '#2e7d32' },
  { key: 'failed', label: 'Failed', color: '#c62828' },
  { key: 'notProven', label: 'Not yet proven', color: '#e0a526' },
  { key: 'notApplicable', label: 'Not applicable', color: '#cfd8dc' }
];

export const TestBar = ({ totals, width = 200 }) => {
  if (!totals || !totals.total) return <Typography variant="caption" sx={{ color: MUTED }}>No test plan</Typography>;
  const values = { passed: totals.passed, failed: totals.failed, notProven: totals.blocked + totals.notExecuted, notApplicable: totals.notApplicable };
  return (
    <Box sx={{ width }}>
      <Box sx={{ display: 'flex', height: 10, borderRadius: 5, overflow: 'hidden', bgcolor: 'rgba(0,0,0,0.06)' }}>
        {SEGMENTS.map((s) => values[s.key] > 0 && (
          <Tooltip key={s.key} title={`${s.label}: ${formatNumber(values[s.key])} of ${formatNumber(totals.total)}`} placement="top">
            <Box sx={{ width: `${(values[s.key] / totals.total) * 100}%`, bgcolor: s.color }} />
          </Tooltip>
        ))}
      </Box>
      <Typography variant="caption" sx={{ color: MUTED }}>
        {formatNumber(totals.total)} tests · {formatPercent(totals.passRate)} passed
      </Typography>
    </Box>
  );
};

export const KindChip = ({ kind }) => (
  <Chip
    size="small"
    label={KIND_LABEL[kind]}
    sx={{ height: 20, borderRadius: '8px', fontWeight: 500, fontSize: '0.7rem', bgcolor: kind === 'hotfix' ? 'rgba(215,75,0,0.12)' : 'rgba(26,46,34,0.08)', color: kind === 'hotfix' ? '#B33F00' : DEEP_GREEN }}
  />
);
